/**
 * Parcels Details
 */

// React
import "date-fns";
import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns";

// Context
import AuthContext from "../../authContext";

//UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import theme from "../../theme";
import {
  Typography,
  Grid,
  Button,
  CircularProgress,
  Box,
  ClickAwayListener,
  Card,
  TextField,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@material-ui/core";
// Icon
import Icon from "@mdi/react";
import {
  mdiKeyOutline,
  mdiPrinter,
  mdiArchiveOutline,
  mdiMapMarkerCheckOutline,
  mdiClose,
  mdiDotsHorizontalCircleOutline,
  mdiClipboardCheckOutline,
  mdiPlaylistCheck,
  mdiCheckBold,
  mdiArrowCollapseAll,
  mdiFileTree,
  mdiClipboardArrowLeft,
  mdiTableArrowUp,
  mdiTableCheck,
  mdiPackageVariantClosed,
  mdiClockAlertOutline,
  mdiUpdate,
  mdiChevronRight,
} from "@mdi/js";

// Components
import ListParcelItems from "./list";
import Can from "../../components/Can";
import CSV from "./csv";
import InventoryItemCSV from "./inventoryItemCsv";
import LabelList from "../parcelInventoryItems/components/labelsList";
import Modal from "../../components/Modal";
import { useForm } from "react-hook-form";

// Helper
import { translate, removeEmptyValueObject } from "../../utils/helpers";
import JalaliUtils from "@date-io/jalaali";

// Type
import { Props } from "./interfaces";
import Pagination from "@material-ui/lab/Pagination";
import RenderFilter, { Filter } from "../../utils/listDaynamicFilter";
import clsx from "clsx";
import parcelsRepository from "client-sdk/src/Repository/parcels-repository";
import inventoryItemsRepository from "client-sdk/src/Repository/inventory-items-repository";
import getProductFileReq from "client-sdk/src/products/files";
import handleError from "../../utils/handleError";
import handleNotfication from "../../utils/handleNotification";
import {
  MuiPickersUtilsProvider,
  DatePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import parcelItemsRepository from "client-sdk/src/Repository/parcel-items-repository";
import ProductRepository from "client-sdk/src/Repository/product-repository";
import { getBlockingTickets } from "../../api/ticket/get";
import ParcelInfoCard from "./components/parcelInfo";
import CustomizedItemsCard from "./components/customizedItemsCard";
import HistoryLog from "./components/historyLog";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        "@media (max-width: 768px)": {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: "16px",
      marginBottom: "16px",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: "1px solid #ddd",
      borderRadius: "4px",
    },

    item: {
      marginBottom: "24px",
      display: "flex",
      alignSelf: "center",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: "98%",
      margin: "10px auto",
    },
    iconButton: {
      padding: 8,
      marginRight: "10px",
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        width: "1px",
        height: "36px",
        top: "4px",
        left: "-9px",
        backgroundColor: "#EDF1F4",
      },
    },
    title: {
      fontWeight: 500,
    },
    filterBox: {
      position: "absolute",
      backgroundColor: "#fff",
      width: "70%",
      marginTop: "30px",
      top: "180px",
      right: "33px",
      borderRadius: "0  0 4px  4px",
      padding: "16px 16px",
      boxSizing: "border-box",
      boxShadow: "0px 2px 4px 1px rgba(0,0,0,0.1)",
      zIndex: 10,
    },
    filterOpen: {
      display: "block",
    },
    label: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 600,
      // color: '#8A8A8A',
      marginRight: "10px",
      // flex: 0.5,
    },
    headerBox: {
      display: "flex",
      alignItems: "center",
      marginBottom: "28px",
    },
    contentlabelTitle: {
      position: "relative",
      color: theme.palette.gray.light,
      marginLeft: "40px",
      fontSize: "14px",
      fontWeight: 500,
      "&:before": {
        content: '"-"',
        position: "absolute",
        left: "-20px",
      },
    },
    loading: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      // height: '50vh',
      width: "100%",
      alignSelf: "center",
      justifyContent: "center",
      background: "#25368C33",
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
    cancelTitle: {
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "justify",
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.blue.main,
      },
    },
    collapseIcon: {
      marginTop: "-36px",
      textAlign: "center",
      position: "relative",
      width: "100%",
      // marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "40px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "40px",
        borderRadius: "50%",
        backgroundColor: theme.palette.secondary.main,
        border: "5px solid white",
      },
    },
    contentBox: {
      marginTop: "-1px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "14px",
      fontWeight: 500,
      textAlign: "right",
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: "10px",
      fontWeight: 400,
    },

    missingOppositeContent: {
      "&::before": {
        flex: "none",
      },
    },
    paperHistory: {
      alignItems: "center",
    },
    bodyContainer: {
      backgroundColor: "#fff",
      padding: "24px",
      borderRadius: "4px",
    },
    itemContainer: {
      border: "1px solid #D9D9D9",
      padding: "18px",
    },
    itemList: {
      display: "flex",
      justifyContent: "space-between",
      gap: "10px",
      margin: "24px 0",
      "& span": {
        fontSize: "16px",
      },
    },
  })
);

//Aryan
export type Input = {
  serial: string;
};

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [filters, setFilters] = useState([] as Filter[]);
  const [filtersValues, setFiltersValues] = useState({
    parcelId: { equals: props.match.params.id },
    page: 0,
    size: 100,
  } as any);
  const [loading, setLoading] = useState(false);
  const [inventoryItemsLoading, setInventoryItemsLoading] = useState(false);
  const [inventoryItemsWithSerialLoading, setInventoryItemsWithSerialLoading] =
    useState(false);
  const [ticket, setTicket] = useState(null);
  const [parcel, setParcel] = useState<any>({});
  const [inventoryItems, setInventoryItems] = useState([]);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState([]);
  const [inventoryItemsCount, setInventoryItemsCount] = useState(0);
  const [openFilterBox, setOpenFilterBox] = React.useState(false);
  const [selected, setSelected] = React.useState<string[]>([]);
  const classes = useStyles();
  const [unitSerial, setUnitSerial] = useState("");
  const [itemId, setItemId] = useState("");
  const [itemCount, setItemCount] = useState(0);
  const [rootCause, setRootCause] = useState("");
  const [numberOfConflict, setNumberOfConflict] = useState(0);
  const [modal, setModal] = useState("");
  const [conflictId, setConflictId] = useState(null);
  const [conflicts, setConflicts] = useState([]);

  //Production and Expiration Date Related (Aryan)
  const [productionDate, setProductionDate] = useState<Date>(new Date());
  const [expirationDate, setExpirationDate] = useState<Date>();
  const [chosenParcelItemId, setChosenParcelItemId] = useState<number>();
  const [miladiDate, setmiladiDate] = useState(false);
  const [dataUpdated, setDataUpdated] = useState<boolean>(false);
  const { handleSubmit } = useForm<Input>({
    defaultValues: {
      serial: "",
    },
  });

  const setupFilters = () => {
    setFilters([
      {
        type: "input",
        id: "productName.contains",
        label: "نام کالا",
        icon: mdiArchiveOutline,
      },
      {
        type: "input",
        id: "productCode.contains",
        label: "کد کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "number",
        id: "productId.equals",
        label: "شناسه کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "number",
        id: "skuId.equals",
        label: "شناسه تنوع کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "input",
        id: "skuCode.contains",
        label: "کد تنوع کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "input",
        id: "serialNumber.equals",
        label: "سریال کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "checkbox",
        id: "status.equals",
        data: ["LOCATED"],
        translateType: "InventoryItemStatus",
        label: "وضعیت کالا",
        icon: mdiKeyOutline,
      },
    ]);
  };

  const getParcelWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await parcelsRepository.getParcelsWithId({ payload });
      setParcel(response.data);
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const clearnParcelInventoryItems = () => {
    setInventoryItemsCount(0);
    setInventoryItems([]);
  };
  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action, size: 10000 };
    try {
      setInventoryItemsWithSerialLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getInventoryItemsWithSerial(
          { payload },
          payload.callback
        );
      if (callback) {
        callback();
      }
      setInventoryItemsWithSerial(response.data.content);
      if (response.data.content.length === 0)
        handleNotfication("هیچ آیتمی پیدا نشد.", "warn");
    } catch (error) {
      handleError(error.response);
    } finally {
      setInventoryItemsWithSerialLoading(false);
    }
  };
  useEffect(() => {
    const { id } = props.match.params;
    getParcelWithId(id);
    getInventoryItemsWithSerial({
      ...filtersValues,
    });
    getTicket();
    return () => {
      clearnParcelInventoryItems();
    };
  }, []);

  const getTicket = async () => {
    const { id } = props.match.params;
    try {
      const res = await getBlockingTickets({ linkType: "parcel", linkId: id });
      setTicket(res.data[0]);
      res.data.length > 0 &&
        handleNotfication("محموله دارای تیکت است.", "warn");
    } catch (error) {
      handleError(error);
    }
  };
  const getParcelInventoryItem = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getParcelInventoryItems({ payload });
      if (callback) {
        callback();
      }
      setInventoryItems(response.data.content);
      setInventoryItemsCount(response.data.totalElements);
    } catch (error) {
      handleError(error.response);
    } finally {
      setInventoryItemsLoading(false);
    }
  };
  useEffect(() => {
    getParcelInventoryItem({
      ...filtersValues,
    });
    setupFilters();
  }, [filtersValues]);

  const handleClickFilter = () => {
    setOpenFilterBox((prev) => !prev);
  };

  useEffect(() => {
    if (parcel?.conflicts?.length > 0) {
      getConflictsSkus();
    }
  }, [parcel]);

  const getConflictsSkus = async () => {
    const ids = parcel.conflicts.map((el) => el.skuId);
    try {
      const { response } = await ProductRepository.getVariantByWarehouse({
        payload: {
          data: ids,
        },
      });

      setConflicts(
        response.data.map((el) => {
          return {
            ...el,
            ...parcel?.conflicts.filter((con) => con.skuId == el.id)[0],
          };
        })
      );
    } catch (error) {
      handleError(error?.response);
    }
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute("dir") !== "rtl" &&
      e.target.getAttribute("type") !== "checkbox" &&
      e.target.getAttribute("class") !== "PrivateSwitchBase-input-73" &&
      e.target.getAttribute("class") !==
        "MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock" &&
      e.target.getAttribute("aria-hidden") !== "true"
    )
      setOpenFilterBox(false);
  };

  const handleOpenPrintModal = () => {
    setModal("PRINT");
  };

  const handleClosePrintModal = () => {
    setModal("");
  };

  const handleClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = inventoryItems.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClickPrint = () => {
    props.history.push(
      `/print-labels/${props.match.params.id}?items=${selected.join(",")}`
    );
  };

  const locateWithParcelItem = async (e: any) => {
    e.preventDefault();
    const { id } = props.match.params;
    const payload = {
      id: itemId,
      body: [
        {
          barcode: parseInt(unitSerial),
          count: itemCount,
        },
      ],
      callback: () => {
        getParcelWithId(id);
        setModal("");
      },
    };
    try {
      setLoading(true);
      const callback = await inventoryItemsRepository.locateParcelItemsUnit({
        payload,
      });
      handleNotfication(
        "تغییر وضعیت آیتم محموله با موفقیت انجام شد",
        "success"
      );
      callback && callback();
      setLoading(false);
    } catch (error) {
      handleError(error.response);
    }
  };

  //Aryan Changes
  const handleOpenExpirationDateModal = (passedData: any) => {
    setModal("EXPDATE");
    setChosenParcelItemId(passedData.id);
    if (!dataUpdated) {
      setProductionDate(
        new Date(passedData.inventoryItems[0].productionDate || new Date())
      );
      setExpirationDate(
        new Date(passedData.inventoryItems[0].expirationDate || new Date())
      );
    }
  };

  const submitExpDate = (data: any) => {
    updateParcelProdExpDate(data);
  };

  const handleProductionDateChange = (date: Date) => {
    const newDate = new Date(date);
    setProductionDate(newDate);
  };

  const handleExpirationDateChange = (date: Date) => {
    const newDate = new Date(date);
    setExpirationDate(newDate);
  };

  const dateFormatter = (date: Date) => {
    return `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${(
      "0" + date.getDate()
    ).slice(-2)}`;
  };

  const updateParcelProdExpDate = async () => {
    const payload = {
      id: chosenParcelItemId,
      body: {
        productionDate: dateFormatter(productionDate),
        expirationDate: dateFormatter(expirationDate),
      },

      callback: () => {
        // getParcelWithId(id);
        setModal("");
      },
    };
    try {
      setLoading(true);
      const callback = await parcelItemsRepository.updateParcelProdExpDate({
        payload,
      });

      handleNotfication(
        "تغییر تاریخ تولید و انقضاء با موفقیت انجام شد",
        "success"
      );
      callback && callback();
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
      setProductionDate(productionDate);
      setExpirationDate(expirationDate);
      setDataUpdated(true);
    }
  };

  const openConflictModal = (id: string) => {
    setConflictId(id);
    setModal("CONFLICT");
  };

  const submitConflict = async () => {
    if (!rootCause || !numberOfConflict) {
      handleNotfication("تعداد و علت مغایرت الزامی است", "error");
      return;
    }
    try {
      await parcelItemsRepository.submitConflict({
        payload: {
          id: conflictId,
          body: [
            {
              conflictRootCause: rootCause,
              count: numberOfConflict,
              inventoryItemSerialNumbers: [],
            },
          ],
        },
      });
      getParcelWithId(props.match.params.id);
      setRootCause("");
      setNumberOfConflict(0);
      setModal("");
      handleNotfication("مغایرت با موفقیت ثبت شد.", "success");
    } catch (error) {
      handleError(error);
    }
  };

  const downloadImage = async (id: number, name: string) => {
    try {
      const response = await getProductFileReq(id);
      const file = URL.createObjectURL(response.blob);
      const link = document.createElement("a");
      link.href = file;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      handleError(error);
    }
  };

  const openLocateModal = (id: string, itemCount: number) => {
    setItemId(id);
    setModal("LOCATE");
    setItemCount(itemCount);
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}>
          <Icon path={mdiChevronRight} size={1} className={classes.icon} />
        </Button>
        <Typography variant="h6" component="h2">
          {`
        جزيیات محموله 
        ${parcel.destinationName}
        `}
        </Typography>
        {/* <span className={classes.contentlabelTitle}>{parcel.id}</span> */}
      </div>
      <div className={classes.bodyContainer}>
        <Grid container lg={12}>
          <Grid lg={2}>
            <Typography
              variant="h6"
              component="h2"
              style={{
                position: "sticky",
                top: "24px",
                marginBottom: "24px",
                fontWeight: "bold",
              }}>
              اطلاعات محموله - {parcel.id}
            </Typography>
            <ParcelInfoCard
              parcel={parcel}
              inventoryItemsCount={inventoryItemsCount}
            />
          </Grid>
          <Grid lg={10}>
            <Typography
              variant="h6"
              component="h2"
              style={{
                marginRight: "24px",
                marginBottom: "24px",
                fontWeight: "bold",
              }}>
              خدمات پیشرفته ورود
            </Typography>
            <CustomizedItemsCard
              parcel={parcel}
              userRole={authContext.user.role}
              reloadPage={() => getParcelWithId(props.match.params.id)}
            />
            <Typography
              variant="h6"
              component="h2"
              style={{
                marginRight: "24px",
                marginBottom: "24px",
                fontWeight: "bold",
              }}>
              جزئیات محموله
            </Typography>
            <Grid
              container
              direction="row"
              justify="flex-end"
              style={{ marginBottom: "24px", marginTop: "24px" }}>
              <Grid
                item
                md={12}
                style={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  marginRight: "24px",
                }}>
                {loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  parcel?.items && (
                    <>
                      {ticket && (
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            history.push(`/ticketing/${ticket?.id}`);
                          }}>
                          سابقه تیکت
                        </Button>
                      )}
                      <Can
                        role={authContext.user.role}
                        perform="/parcels/receipts/:id"
                        yes={() => (
                          <Link
                            to={`/parcels/receipts/${parcel.id}`}
                            target="_blank"
                            style={{ textDecoration: "none" }}>
                            <Button
                              variant="contained"
                              color="primary"
                              size="medium"
                              style={{
                                marginRight: "8px",
                                padding: "8px 10px",
                              }}
                              endIcon={<Icon path={mdiPrinter} size={1} />}>
                              چاپ رسید
                            </Button>
                          </Link>
                        )}
                      />
                      <Can
                        perform="parcels-details:print"
                        role={authContext.user.role}
                        yes={() => (
                          <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ marginRight: "8px", padding: "4px 10px" }}
                            endIcon={<Icon path={mdiPrinter} size={1} />}
                            onClick={handleOpenPrintModal}>
                            {"چاپ سریال"}
                          </Button>
                        )}
                      />
                      <Can
                        role={authContext.user.role}
                        perform="parcels-detail:downloadInventoryItemCSV"
                        yes={() => (
                          <>
                            {inventoryItemsWithSerial?.length && (
                              <InventoryItemCSV
                                ordersDispatch={getInventoryItemsWithSerial}
                                data={inventoryItemsWithSerial}
                                filtersValues={filtersValues}
                                loading={inventoryItemsWithSerialLoading}
                              />
                            )}
                          </>
                        )}
                      />

                      <Can
                        role={authContext.user.role}
                        perform="parcels-detail:downloadCSV"
                        yes={() => (
                          <>
                            {parcel?.items?.length && (
                              <CSV
                                ordersDispatch={getParcelInventoryItem}
                                data={parcel?.items}
                                filtersValues={filtersValues}
                                loading={inventoryItemsLoading}
                              />
                            )}
                          </>
                        )}
                      />
                      {/* <Grid
                        item
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginLeft: '10px',
                        }}
                      >
                        <Checkbox
                          checked={!!parcel?.hasVipQc}
                          onClick={handleQCVIPCheckbox}
                        />
                        <span>کنترل کیفیت ویژه</span>
                      </Grid> */}
                    </>
                  )
                )}
              </Grid>
            </Grid>
            <Card
              style={{
                paddingTop: "0",
                marginRight: "24px",
                marginTop: "24px",
                marginBottom: "24px",
              }}>
              {loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                parcel?.items && (
                  <>
                    <ListParcelItems
                      data={parcel.items.filter((el) => !el.hasConflict)}
                      locateClick={openLocateModal}
                      handleOpenExpirationDateModal={
                        handleOpenExpirationDateModal
                      }
                      openConflictModal={openConflictModal}
                      hasConflict={parcel.hasConflict}
                      conflicts={conflicts}
                      downloadImage={downloadImage}
                    />
                  </>
                )
              )}
            </Card>
            <Typography
              variant="h6"
              component="h2"
              style={{
                marginRight: "24px",
                marginBottom: "24px",
                fontWeight: "bold",
              }}>
              تاریخچه محموله
            </Typography>
            <HistoryLog
              id={props.match.params.id}
              userRole={authContext.user.role}
            />
          </Grid>
        </Grid>
      </div>
      <Modal
        maxWidth="xl"
        onClose={handleClosePrintModal}
        open={modal === "PRINT"}
        title={
          <div style={{ textAlign: "center" }}>
            <Icon path={mdiPrinter} size={4} color={theme.palette.green.main} />
          </div>
        }
        content={
          <Grid container>
            <Grid item md={6}>
              <span>تعداد کل: {inventoryItemsCount}</span>
              <br />
              <span>تعداد در صفحه: {inventoryItems?.length}</span>
            </Grid>
            <Grid
              container
              justify="flex-end"
              item
              xs={12}
              md={6}
              style={{ marginBottom: "5px" }}>
              <ClickAwayListener onClickAway={handleClickAway}>
                <div>
                  <Button
                    type="button"
                    onClick={handleClickFilter}
                    className={classes.iconButton}
                    aria-label="search">
                    {openFilterBox ? "بستن" : "جستجوی پیشرفته"}
                  </Button>
                  {openFilterBox ? (
                    <div
                      className={clsx(classes.filterBox, {
                        [classes.filterOpen]: openFilterBox,
                      })}>
                      <RenderFilter
                        filters={filters}
                        onFilter={(filtervalues: any) => {
                          setFiltersValues({
                            ...removeEmptyValueObject(filtervalues),
                            parcelId: { equals: props.match.params.id },
                            page: 0,
                            size: 100,
                          });
                          setOpenFilterBox(false);
                        }}
                        setOpenFilterBox={setOpenFilterBox}
                      />
                    </div>
                  ) : null}
                </div>
              </ClickAwayListener>
            </Grid>
            <Grid xs={12} style={{ marginBottom: "20px", marginTop: "20px" }}>
              <LabelList
                selected={selected}
                handleSelectAllClick={handleSelectAllClick}
                handleClick={handleClick}
                data={inventoryItems}
              />
            </Grid>
            <Box mb={4} />
            <Grid xs={12} container justify="space-between" alignItems="center">
              <Pagination
                count={Math.ceil(inventoryItemsCount / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
              <Button
                disabled={selected.length < 1}
                variant="contained"
                color="secondary"
                size="large"
                onClick={handleClickPrint}
                startIcon={<Icon path={mdiPrinter} size={1} />}>
                {"پرینت سریال‌ها"}
              </Button>
            </Grid>
          </Grid>
        }
      />
      <Modal
        maxWidth="xl"
        onClose={() => setModal("")}
        open={modal === "LOCATE"}
        title={
          <div style={{ textAlign: "center" }}>
            <Icon
              style={{ color: "#0cc9c9" }}
              path={mdiPackageVariantClosed}
              size={2}
            />
          </div>
        }
        content={
          <form style={{ width: "500px" }} onSubmit={locateWithParcelItem}>
            <Typography style={{ marginBottom: "8px" }}>
              سریال یونیت مورد نظر را اسکن کنید:
            </Typography>
            <TextField
              fullWidth
              autoFocus
              label="سریال"
              variant="outlined"
              value={unitSerial}
              onChange={(e) => {
                setUnitSerial(e.target.value);
              }}
            />
            <Grid
              container
              justifyContent="flex-end"
              style={{ marginTop: "16px" }}>
              <Button
                type="submit"
                style={{ alignSelf: "flex-end" }}
                color="secondary"
                variant="contained">
                جایگذاری کالا
              </Button>
            </Grid>
          </form>
        }
      />
      <Modal
        maxWidth="lg"
        onClose={() => setModal("")}
        open={modal === "EXPDATE"}
        title={
          <div>
            <Icon
              path={mdiClockAlertOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <form onSubmit={handleSubmit(submitExpDate)}>
            <Grid container xs={12} sm={12} lg={12} spacing={2}>
              <Grid item md={12}>
                <Checkbox
                  value={miladiDate}
                  onChange={(e, check) => setmiladiDate(check)}
                />
                <span>تاریخ میلادی</span>
              </Grid>
              <Grid item xs={6} sm={6} lg={6} spacing={2}>
                <div className={classes.item}>
                  {miladiDate ? (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        inputVariant="outlined"
                        id="productionDate"
                        name="productionDate"
                        label="انتخاب تاریخ تولید"
                        format="yyyy/MM/dd"
                        value={productionDate}
                        fullWidth
                        okLabel="تأیید"
                        cancelLabel="لغو"
                        defaultValue={new Date()}
                        onChange={handleProductionDateChange}
                      />
                    </MuiPickersUtilsProvider>
                  ) : (
                    <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                      <DatePicker
                        inputVariant="outlined"
                        id="productionDate"
                        name="productionDate"
                        label="انتخاب تاریخ تولید"
                        format="jYYYY/jMM/jDD"
                        value={productionDate}
                        fullWidth
                        okLabel="تأیید"
                        cancelLabel="لغو"
                        defaultValue={new Date()}
                        onChange={handleProductionDateChange}
                      />
                    </MuiPickersUtilsProvider>
                  )}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} lg={6} spacing={2}>
                <div className={classes.item}>
                  {miladiDate ? (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        inputVariant="outlined"
                        id="expirationDate"
                        name="expirationDate"
                        label="انتخاب تاریخ انقضاء"
                        format="yyyy/MM/dd"
                        value={expirationDate}
                        fullWidth
                        okLabel="تأیید"
                        cancelLabel="لغو"
                        defaultValue={new Date()}
                        onChange={handleExpirationDateChange}
                      />{" "}
                    </MuiPickersUtilsProvider>
                  ) : (
                    <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                      <DatePicker
                        inputVariant="outlined"
                        id="expirationDate"
                        name="expirationDate"
                        label="انتخاب تاریخ انقضاء"
                        format="jYYYY/jMM/jDD"
                        value={expirationDate}
                        fullWidth
                        okLabel="تأیید"
                        cancelLabel="لغو"
                        defaultValue={new Date()}
                        onChange={handleExpirationDateChange}
                      />
                    </MuiPickersUtilsProvider>
                  )}
                </div>
              </Grid>

              <Grid xs={12} container justify="flex-end">
                <Grid item>
                  <Button
                    variant="contained"
                    color="secondary"
                    type="submit"
                    size="large"
                    startIcon={<Icon path={mdiUpdate} size={1} />}>
                    {"به‌روزرسانی تاریخ"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        }
      />

      <Modal
        maxWidth="lg"
        onClose={() => setModal("")}
        open={modal === "CONFLICT"}
        title={
          <div>
            {parcel.items && (
              <p>
                اعلام مغایرت کالای{" "}
                {
                  parcel?.items.filter((el) => el.id === conflictId)[0]
                    ?.productName
                }
              </p>
            )}
          </div>
        }
        content={
          <>
            <div
              style={{ display: "flex", width: "50%", alignItems: "center" }}>
              <p style={{ margin: 0 }}>تعداد: </p>
              <input
                onChange={(e) => setNumberOfConflict(e.target.value)}
                value={numberOfConflict}
                type="number"
                style={{
                  width: "60px",
                  borderRadius: "4px",
                  marginRight: "12px",
                  border: "1px solid #000000",
                  padding: "5px",
                }}
              />
            </div>
            <p>علت مغایرت را مشخص نمایید.</p>
            <RadioGroup
              aria-label="gender"
              name="gender1"
              value={rootCause}
              onChange={(e) => setRootCause(e.target.value)}>
              <FormControlLabel
                value="LESS_THAN_SUBMITTED"
                control={<Radio />}
                label="تعداد کمتر"
              />
              <FormControlLabel
                value="PHYSICAL_CONFLICT"
                control={<Radio />}
                label="مشکل فیزیکی"
              />
              {/* <FormControlLabel
                value="VAN"
                control={<Radio />}
                label="وانت سبک"
              />
              <FormControlLabel
                value="VAN_HEAVY"
                control={<Radio />}
                label="وانت سنگین"
              /> */}
            </RadioGroup>
            <div style={{ display: "flex" }}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: "auto" }}
                onClick={submitConflict}>
                ذخیره
              </Button>
            </div>
          </>
        }
      />
    </div>
  );
}

export default Details;
